import { Button, Table } from '~/components';
import { TableBoxRowActions } from '~/components/table';
import { useApi } from '~/contexts';
import { useDocumentTitle } from '~/hooks';
import React, { useCallback, useEffect, useState } from 'react';
import { ErrorPage, PageLoader } from '~/routes/public/pages';
import styled from 'styled-components';
import AdministratorDrawer from './AdministratorDrawer';
import { adminPermissions } from './permissions';

const PageArea = styled.div`
  display: flex;
  flex-direction: column;
`;

const Toolbar = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const PermissionList = styled.ul`
  margin: 0;
  padding-left: 1.25rem;
  list-style: disc;
`;

function permissionLabels(keys = []) {
  return adminPermissions.filter((permission) => keys.includes(permission.key)).map((permission) => permission.label);
}

function AdministratorsList() {
  const documentTitle = useDocumentTitle('Administrators');

  const api = useApi();
  const [query, setQuery] = useState({ isReady: false, data: null, error: null });
  const [dialog, setDialog] = useState(null);

  const fetchData = useCallback(async () => {
    try {
      const { data } = await api.admin.administrators.get();
      setQuery({ isReady: true, data });
    } catch (error) {
      setQuery({ isReady: true, data: null, error });
    }
  }, [api]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleEdit = (entry) => {
    setDialog(
      <AdministratorDrawer
        entry={entry}
        onClose={() => {
          setDialog(null);
          documentTitle.set('Administrators');
        }}
        onDeleted={fetchData}
        onSaved={fetchData}
      />,
    );
  };

  if (!query.isReady) return <PageLoader />;
  if (!query.data) return <ErrorPage publicSite={false} />;

  const data = query.data;

  return (
    <PageArea>
      <Toolbar>
        <Button onClick={() => handleEdit({})}>New Administrator</Button>
      </Toolbar>
      <Table.Total value={data.length} label="Administrator" style={{ marginTop: '1rem' }} />
      <Table>
        <Table.BoxHeader>
          <Table.Column>Name</Table.Column>
          <Table.Column>Email</Table.Column>
          <Table.Column width="28rem">Permissions</Table.Column>
          <Table.Column>Status</Table.Column>
          <Table.BoxActionsColumn />
        </Table.BoxHeader>
        <Table.Body>
          {data.map((entry) => {
            const labels = permissionLabels(entry.permissions);
            return (
              <Table.BoxRow onClick={() => handleEdit(entry)} key={entry.id}>
                <Table.Cell>{entry.name}</Table.Cell>
                <Table.Cell>{entry.email}</Table.Cell>
                <Table.Cell>
                  {labels.length > 0 ? (
                    <PermissionList>
                      {labels.map((label) => (
                        <li key={label}>{label}</li>
                      ))}
                    </PermissionList>
                  ) : (
                    'None'
                  )}
                </Table.Cell>
                <Table.Cell>{entry.isActive ? 'Active' : 'Inactive'}</Table.Cell>
                <TableBoxRowActions>
                  <TableBoxRowActions.Edit onClick={() => handleEdit(entry)} />
                </TableBoxRowActions>
              </Table.BoxRow>
            );
          })}
        </Table.Body>
      </Table>

      {dialog}
    </PageArea>
  );
}

export default AdministratorsList;
